import {Article} from '../types';
import {useRoute} from 'react-router5';
import {RouterState} from '../routerMiddleware';

export default function useRelatedArticles(): Array<Article> {
  const count = 3;
  const {route} = useRoute();
  const state = route as RouterState;
  const articles = state?.data?.articles;
  const currentArticle = articles.find(a => a.id === route.params.id);

  if (!currentArticle) {
    return [];
  }

  const biggestOverlap: Array<Article> = [];

  articles.forEach((article) => {
    if (article.id === currentArticle.id) {
      return;
    }
    if (biggestOverlap.length < count) {
      biggestOverlap.push(article);
      return;
    }

    for (let i = 0; i < biggestOverlap.length; i++) {
      if (moreRelevant(currentArticle, article, biggestOverlap[i])) {
        biggestOverlap.splice(i, 0, article);
        if (biggestOverlap.length > count) {
          biggestOverlap.pop();
        }
        return;
      }
    }
  });

  return biggestOverlap;
}

// returns true if a is more relevant than b, false if a is less relevant than b
function moreRelevant(reference: Article, a: Article, b: Article): boolean {
  const tagIdsA = a.tags.map(tag => tag.id);
  const tagIdsB = b.tags.map(tag => tag.id);
  const commonTagsA = reference.tags.filter(tag => tagIdsA.includes(tag.id)).length;
  const commonTagsB = reference.tags.filter(tag => tagIdsB.includes(tag.id)).length;
  if (commonTagsA !== commonTagsB) {
    return commonTagsA > commonTagsB;
  }
  return Date.parse(a.date.toString()) > Date.parse(b.date.toString());
}
